import { render } from "@/components/pages/individualWorkSupport/requirement060/Requirement060.html?vue&type=template&id=1595de79&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement060/Requirement060.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement060/Requirement060.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement060/Requirement060.scss?vue&type=style&index=0&id=1595de79&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1595de79"]])

export default __exports__